export const authLogin = "/auth/login";
export const classContinue = "class/";
export const sectionContinue = "section/";
export const levels = "levels";
export const grades = "grades";
export const lessonContinue = "lesson/";
export const studentContinue = "student/";
export const teacherContinue = "teacher/";
export const parentContinue = "parent/";
export const employeeContinue = "personnel/";